// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zcviSFNaULblaHP7S2fK::-moz-placeholder {\n    color: var(--mantine-color-gray-4);\n    opacity: 1;\n  }\n.zcviSFNaULblaHP7S2fK::placeholder {\n    color: var(--mantine-color-gray-4);\n    opacity: 1;\n  }\n", "",{"version":3,"sources":["webpack://./jsapp/js/theme/kobo/Select.module.css"],"names":[],"mappings":"AACE;IACE,kCAAkC;IAClC,UAAU;EACZ;AAHA;IACE,kCAAkC;IAClC,UAAU;EACZ","sourcesContent":[".input {\n  &::placeholder {\n    color: var(--mantine-color-gray-4);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "zcviSFNaULblaHP7S2fK"
};
export default ___CSS_LOADER_EXPORT___;
